<template>
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.6667 12.5C22.6667 6.97715 18.1896 2.5 12.6667 2.5C7.1439 2.5 2.66675 6.97715 2.66675 12.5H22.6667Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.66675 16C7.66675 18.7614 9.90535 21 12.6667 21C15.4281 21 17.6667 18.7614 17.6667 16H7.66675Z"
            fill="currentColor"
        />
    </svg>
</template>
